import type { EditAsideExpiryDatePicker } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import 'moment/locale/nl-be';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import DatePickerElement from './DatePicker';
import { convertDateToUTCISOString } from './dateHelper';

const AsideDatePicker: React.FC<{
  config: EditAsideExpiryDatePicker;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentValue = useInitialValue(config.property);

  const currentDate = currentValue ? new Date(currentValue) : null;

  const change = (value: Date | null) => {
    dispatch(
      patchNodeAction(
        getResourceKey(editHref),
        set({}, config.property, value ? convertDateToUTCISOString(value) : undefined),
        true,
        null,
        false,
      ),
    );
  };

  return (
    <DatePickerElement config={config} value={currentDate} onChange={change} readonly={readonly} />
  );
};

AsideDatePicker.displayName = 'AsideDatePicker';

export default AsideDatePicker;

AsideDatePicker.propTypes = {
  config: any,
  readonly: any,
};
